webpackJsonp([114258107076074],{

/***/ 1404:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/spending.4c1f8e1c.png";

/***/ }),

/***/ 111:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ReactComponent = undefined;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _extends() {
	  _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }return target;
	  };return _extends.apply(this, arguments);
	}
	
	var _ref =
	/*#__PURE__*/
	_react2.default.createElement("path", {
	  className: "st0",
	  d: "M185.83 6.17H139.8c-4.42 0-8 3.58-8 8s3.58 8 8 8h26.72l-27.97 27.97c-3.12 3.12-3.12 8.19 0 11.31 1.56 1.56 3.61 2.34 5.66 2.34s4.09-.78 5.66-2.34l27.97-27.97V60.2c0 4.42 3.58 8 8 8s8-3.58 8-8V14.17c-.01-4.42-3.59-8-8.01-8z"
	});
	
	var _ref2 =
	/*#__PURE__*/
	_react2.default.createElement("path", {
	  className: "st0",
	  d: "M185.83 108.54c-4.42 0-8 3.58-8 8v61.29h-19.59V100.8h-31.63v77.04h-10.34v-43.16H84.63v43.16H73.39V65.22H41.76v112.61H22.17V22.17h73.06c4.42 0 8-3.58 8-8s-3.58-8-8-8H14.17c-4.42 0-8 3.58-8 8v171.67c0 4.42 3.58 8 8 8h171.67c4.42 0 8-3.58 8-8v-69.29c-.01-4.43-3.59-8.01-8.01-8.01z"
	});
	
	var SvgComponent = function SvgComponent(props) {
	  return _react2.default.createElement("svg", _extends({
	    id: "Layer_1",
	    viewBox: "0 0 200 200"
	  }, props), _ref, _ref2);
	};
	
	exports.default = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4KPCEtLSBHZW5lcmF0b3I6IEFkb2JlIElsbHVzdHJhdG9yIDI0LjIuMywgU1ZHIEV4cG9ydCBQbHVnLUluIC4gU1ZHIFZlcnNpb246IDYuMDAgQnVpbGQgMCkgIC0tPgo8c3ZnIHZlcnNpb249IjEuMSIgaWQ9IkxheWVyXzEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHg9IjBweCIgeT0iMHB4IgoJIHZpZXdCb3g9IjAgMCAyMDAgMjAwIiBzdHlsZT0iZW5hYmxlLWJhY2tncm91bmQ6bmV3IDAgMCAyMDAgMjAwOyIgeG1sOnNwYWNlPSJwcmVzZXJ2ZSI+CjxzdHlsZSB0eXBlPSJ0ZXh0L2NzcyI+Cgkuc3Qwe2ZpbGw6I0Y0NzkyMDt9Cjwvc3R5bGU+CjxnPgoJPHBhdGggY2xhc3M9InN0MCIgZD0iTTE4NS44Myw2LjE3SDEzOS44Yy00LjQyLDAtOCwzLjU4LTgsOHMzLjU4LDgsOCw4aDI2LjcybC0yNy45NywyNy45N2MtMy4xMiwzLjEyLTMuMTIsOC4xOSwwLDExLjMxCgkJYzEuNTYsMS41NiwzLjYxLDIuMzQsNS42NiwyLjM0czQuMDktMC43OCw1LjY2LTIuMzRsMjcuOTctMjcuOTdWNjAuMmMwLDQuNDIsMy41OCw4LDgsOHM4LTMuNTgsOC04VjE0LjE3CgkJQzE5My44Myw5Ljc1LDE5MC4yNSw2LjE3LDE4NS44Myw2LjE3eiIvPgoJPHBhdGggY2xhc3M9InN0MCIgZD0iTTE4NS44MywxMDguNTRjLTQuNDIsMC04LDMuNTgtOCw4djYxLjI5aC0xOS41OVYxMDAuOGgtMzEuNjN2NzcuMDRoLTEwLjM0di00My4xNkg4NC42M3Y0My4xNkg3My4zOVY2NS4yMgoJCUg0MS43NnYxMTIuNjFIMjIuMTdWMjIuMTdoNzMuMDZjNC40MiwwLDgtMy41OCw4LThzLTMuNTgtOC04LThIMTQuMTdjLTQuNDIsMC04LDMuNTgtOCw4djE3MS42N2MwLDQuNDIsMy41OCw4LDgsOGgxNzEuNjcKCQljNC40MiwwLDgtMy41OCw4LTh2LTY5LjI5QzE5My44MywxMTIuMTIsMTkwLjI1LDEwOC41NCwxODUuODMsMTA4LjU0eiIvPgo8L2c+Cjwvc3ZnPgo=";
	exports.ReactComponent = SvgComponent;

/***/ }),

/***/ 587:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.query = undefined;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(8);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _ThemeList = __webpack_require__(66);
	
	var _ThemeList2 = _interopRequireDefault(_ThemeList);
	
	var _PageHeader = __webpack_require__(109);
	
	var _PageHeader2 = _interopRequireDefault(_PageHeader);
	
	var _ThemeNavFooter = __webpack_require__(110);
	
	var _ThemeNavFooter2 = _interopRequireDefault(_ThemeNavFooter);
	
	var _Button = __webpack_require__(31);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _ShareExhibit = __webpack_require__(92);
	
	var _ShareExhibit2 = _interopRequireDefault(_ShareExhibit);
	
	var _iconChart = __webpack_require__(111);
	
	var _iconChart2 = _interopRequireDefault(_iconChart);
	
	var _spending = __webpack_require__(1404);
	
	var _spending2 = _interopRequireDefault(_spending);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Theme2Page = function Theme2Page(_ref) {
	  var data = _ref.data;
	  return _react2.default.createElement(
	    'main',
	    null,
	    _react2.default.createElement(
	      'article',
	      null,
	      _react2.default.createElement(_PageHeader2.default, {
	        data: data.allThemesJson.edges[1].node,
	        img: _spending2.default
	      }),
	      _react2.default.createElement(
	        'div',
	        { className: 'section' },
	        _react2.default.createElement(
	          'div',
	          { className: 'section__content section__summary' },
	          _react2.default.createElement(
	            'p',
	            null,
	            'Health care spending growth is a perpetual policy concern in the United States. High spending threatens the sustainability of public insurance programs and affects premium costs and out-of-pocket cost-sharing for the more than 170 million Americans enrolled in commercial plans.',
	            _react2.default.createElement(
	              'sup',
	              { className: 'note__link' },
	              _react2.default.createElement(
	                'a',
	                { href: '#11' },
	                '11'
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            'Fee-for-service payment models have left many providers financially vulnerable in the wake of social-distancing restrictions and lower demand for care.'
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            'Short-term revenue losses among providers will certainly rebound, but the long-term impact of the pandemic on providers\u2019 bottom line is uncertain.',
	            _react2.default.createElement(
	              'sup',
	              {
	                className: 'note__link' },
	              _react2.default.createElement(
	                'a',
	                { href: '#12' },
	                '12'
	              )
	            ),
	            ' To the extent that volumes remain lower than once expected or the supply of providers decreases within markets, providers may raise prices.'
	          )
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'section' },
	        _react2.default.createElement(
	          'h2',
	          { className: 'section__title' },
	          'Prices paid by commercial insurers are higher than Medicare rates for similar services'
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'section__row section__row__2_up' },
	          _react2.default.createElement(
	            'div',
	            { className: 'section__content section__content__narrow' },
	            _react2.default.createElement(
	              'h3',
	              null,
	              'Researchers and policymakers have been able to track spending for health care services, but only recently have they been able to break down total spending estimates into utilization and price-per-service components. Estimates suggest that about three-quarters of the growth in health care spending between 2014 and 2018 can be attributed to price increases.',
	              _react2.default.createElement(
	                'sup',
	                { className: 'note__link' },
	                _react2.default.createElement(
	                  'a',
	                  { href: '#13' },
	                  '13'
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'section__content section__content__wide' },
	            _react2.default.createElement(
	              'p',
	              null,
	              'A recent state analysis compared prices paid by commercial employer-sponsored plans for inpatient hospital services to Medicare payment rates for similar services. It found significant variation, with commercial insurers paying between 140 percent of Medicare prices in Hawaii and 274 percent in Oregon.',
	              _react2.default.createElement(
	                'sup',
	                { className: 'note__link' },
	                _react2.default.createElement(
	                  'a',
	                  {
	                    href: '#14' },
	                  '14'
	                )
	              ),
	              ' ',
	              _react2.default.createElement(
	                _gatsbyLink2.default,
	                { to: '/spending/#exhibit-5' },
	                _react2.default.createElement(
	                  'span',
	                  {
	                    className: 'exhibit__link' },
	                  _react2.default.createElement(_iconChart.ReactComponent, null)
	                )
	              ),
	              ' Prices can vary for a number of reasons. In Rhode Island, for example, where prices are 158 percent of Medicare, the state drove down prices through insurer rate regulation.',
	              _react2.default.createElement(
	                'sup',
	                {
	                  className: 'note__link' },
	                _react2.default.createElement(
	                  'a',
	                  { href: '#15' },
	                  '15'
	                )
	              ),
	              ' The presence of market-dominant, not-for-profit insurers with strong price negotiation leverage also can work to mitigate higher prices.'
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              'High prices have consequences. When health providers charge private insurers higher prices, insurers pass along those higher costs to employers by increasing premiums. Ultimately, employees bear the burden through higher premium contributions, deductibles, out-of-pocket medical costs, and reduced wages. States where providers charge the highest prices also tended to have the highest average premium costs in terms of both employer and employee contributions. ',
	              _react2.default.createElement(
	                _gatsbyLink2.default,
	                {
	                  to: '/spending/#exhibit-6' },
	                _react2.default.createElement(
	                  'span',
	                  { className: 'exhibit__link' },
	                  _react2.default.createElement(_iconChart.ReactComponent, null)
	                )
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { id: 'exhibit-5',
	            className: 'section__content section__exhibit section__exhibit__padded section__content__wide' },
	          _react2.default.createElement(
	            'h2',
	            { className: 'exhibit__title__block' },
	            'Prices for hospital inpatient care paid by commercial insurers are higher than Medicare prices in every state'
	          ),
	          _react2.default.createElement(
	            'figure',
	            null,
	            _react2.default.createElement('img', { className: 'exhibit__image__padded',
	              src: (0, _gatsbyLink.withPrefix)('/img/exhibits/exhibit-5-web.png'), alt: '' }),
	            _react2.default.createElement(
	              'figcaption',
	              null,
	              _react2.default.createElement(
	                'p',
	                null,
	                'Note: Data not available for District of Columbia, Maryland, or South Carolina.'
	              ),
	              _react2.default.createElement(
	                'p',
	                null,
	                'Data: 2017 IBM Watson Health MarketScan Database and Medicare\u2019s Healthcare Cost Report Information System (HCRIS); Michael E. Chernew, Andrew L. Hicks, and Shivani A. Shah, \u201CWide State-Level Variation in Commercial Health Care Prices Suggests Uneven Impact of Price Regulation,\u201D Health Affairs, published online May 4, 2020.'
	              )
	            )
	          ),
	          _react2.default.createElement(_ShareExhibit2.default, {
	            exhibit: 'exhibit-05',
	            site: data.site.siteMetadata,
	            social: data.allSocialJson.edges
	          })
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { id: 'exhibit-6',
	          className: 'section__content section__exhibit section__exhibit__padded section__full' },
	        _react2.default.createElement(
	          'h2',
	          { className: 'exhibit__title__block' },
	          'Higher premiums for employer coverage are associated with higher commercial prices for health care services, 2017'
	        ),
	        _react2.default.createElement(
	          'figure',
	          null,
	          _react2.default.createElement('img', { className: 'exhibit__image__padded',
	            src: (0, _gatsbyLink.withPrefix)('/img/exhibits/exhibit-6-web.png'), alt: '' }),
	          _react2.default.createElement(
	            'figcaption',
	            null,
	            _react2.default.createElement(
	              'p',
	              null,
	              'Notes: The x-axis and y-axis do not start at $0. State abbreviations left off some data points clustered near the U.S. average for legibility.'
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              'Data: Prices: 2017 IBM Watson Health MarketScan Database, analysis by Michael Chernew, Harvard Medical School. Premiums: Medical Expenditure Panel Survey\u2013Insurance Component (MEPS-IC, 2017).'
	            )
	          )
	        ),
	        _react2.default.createElement(_ShareExhibit2.default, {
	          exhibit: 'exhibit-06',
	          site: data.site.siteMetadata,
	          social: data.allSocialJson.edges
	        })
	      ),
	      _react2.default.createElement('hr', { className: 'section__divider' }),
	      _react2.default.createElement(
	        'div',
	        { className: 'section' },
	        _react2.default.createElement(
	          'h2',
	          { className: 'section__title' },
	          'U.S. investment in primary care is low and could be further weakened by the pandemic.'
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'section__row section__row__2_up' },
	          _react2.default.createElement(
	            'div',
	            { className: 'section__content' },
	            _react2.default.createElement(
	              'p',
	              null,
	              'The COVID-19 pandemic fueled a 70 percent drop in in-person outpatient visits in March 2020, including a 50 percent drop for primary care providers. This was the result of social distancing restrictions, public fear of the virus, and safety precautions taken by providers.',
	              _react2.default.createElement(
	                'sup',
	                { className: 'note__link' },
	                _react2.default.createElement(
	                  'a',
	                  {
	                    href: '#16' },
	                  '16'
	                )
	              ),
	              ' Visit volumes have rebounded somewhat, and that will continue. Still, primary care\u2019s vulnerability to steep demand and revenue declines is concerning.'
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'section__content' },
	            _react2.default.createElement(
	              'p',
	              null,
	              'Pre-COVID data on primary care spending can inform our eventual understanding of the outbreak\u2019s impact. Among Medicare beneficiaries in 2017, for example, primary care accounted for just under 6 percent of all medical spending, translating to about $712 per beneficiary per year nationally. State rates ranged from less than 5 percent in Rhode Island and New Hampshire to more than 7 percent in Tennessee. ',
	              _react2.default.createElement(
	                _gatsbyLink2.default,
	                {
	                  to: '/spending/#exhibit-7' },
	                _react2.default.createElement(
	                  'span',
	                  {
	                    className: 'exhibit__link' },
	                  _react2.default.createElement(_iconChart.ReactComponent, null)
	                )
	              ),
	              ' American investment in primary care was already low relative to international benchmarks. Among Medicare beneficiaries, for example, primary care spending amounts to only about half the OECD country average of 12 percent.',
	              _react2.default.createElement(
	                'sup',
	                { className: 'note__link' },
	                _react2.default.createElement(
	                  'a',
	                  { href: '#17' },
	                  '17'
	                )
	              ),
	              ' There is significant uncertainty about whether the combined effects of the pandemic and economic collapse will further drive down primary care use. If that scenario materializes, forgone care and subsequent gaps in chronic disease management will contribute to avoidable illness and higher non-COVID mortality.',
	              _react2.default.createElement(
	                'sup',
	                { className: 'note__link' },
	                _react2.default.createElement(
	                  'a',
	                  { href: '#18' },
	                  '18'
	                )
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { id: 'exhibit-7',
	            className: 'section__content section__exhibit section__exhibit__padded section__full' },
	          _react2.default.createElement(
	            'h2',
	            { className: 'title__block' },
	            'The percentage of total Medicare spending on primary care is low throughout the U.S., but it varies by more than 50 percent across states'
	          ),
	          _react2.default.createElement(
	            'figure',
	            null,
	            _react2.default.createElement('img', { src: (0, _gatsbyLink.withPrefix)('/img/exhibits/exhibit-7-web.png'), alt: '' }),
	            _react2.default.createElement(
	              'figcaption',
	              null,
	              _react2.default.createElement(
	                'p',
	                null,
	                'Data: Centers for Medicare and Medicaid Services, 2017 Limited Data Set (LDS) 5% sample. Analysis by Westat.'
	              )
	            )
	          ),
	          _react2.default.createElement(_ShareExhibit2.default, {
	            exhibit: 'exhibit-07',
	            site: data.site.siteMetadata,
	            social: data.allSocialJson.edges
	          })
	        )
	      ),
	      _react2.default.createElement('hr', { className: 'section__divider' }),
	      _react2.default.createElement(
	        'div',
	        { className: 'section section__heavy' },
	        _react2.default.createElement(
	          'div',
	          { className: 'section__row section__row__2_up' },
	          _react2.default.createElement(
	            'div',
	            { className: 'section__content section__content__narrow' },
	            _react2.default.createElement(
	              'h2',
	              null,
	              'What Can Be Done?'
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'section__content section__content__wide' },
	            _react2.default.createElement(
	              'h3',
	              null,
	              'Many states are pursuing policies to address health care spending, including some that directly address health care service prices. For example, Rhode Island has driven down commercial health care prices through insurer rate regulation, and Washington State will launch a public option in 2021 that pays providers closer to Medicare rates. Other states are using collaborative purchasing to lower health care costs in state employee benefit programs. '
	            )
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(_ThemeNavFooter2.default, { themes: data.allThemesJson.edges }),
	    _react2.default.createElement(
	      'div',
	      { className: 'section section__notes' },
	      _react2.default.createElement(
	        'div',
	        { className: 'section__row' },
	        _react2.default.createElement(
	          'div',
	          { className: 'section__content' },
	          _react2.default.createElement(
	            'ol',
	            { start: '11', style: { counterReset: 'item 10' }, className: 'list__notes' },
	            _react2.default.createElement(
	              'li',
	              { id: '11' },
	              'CBO, ',
	              _react2.default.createElement(
	                'em',
	                null,
	                'Federal Subsidies'
	              ),
	              ', 2019.'
	            ),
	            _react2.default.createElement(
	              'li',
	              { id: '12' },
	              'Michael E. Chernew, "',
	              _react2.default.createElement(
	                'a',
	                {
	                  href: 'https://www.healthaffairs.org/do/10.1377/hblog20200417.842451/full/' },
	                _react2.default.createElement(
	                  'span',
	                  null,
	                  'How to Read National Health Expenditure Projections in Light of COVID-19: Uncertain Long-Run Effects, but Challenges for All'
	                )
	              ),
	              '," ',
	              _react2.default.createElement(
	                'em',
	                null,
	                'Health Affairs Blog'
	              ),
	              ', Apr. 20, 2020.'
	            ),
	            _react2.default.createElement(
	              'li',
	              { id: '13' },
	              'Health Care Cost Institute, ',
	              _react2.default.createElement(
	                'a',
	                {
	                  href: 'https://healthcostinstitute.org/images/pdfs/HCCI_2018_Health_Care_Cost_and_Utilization_Report.pdf' },
	                _react2.default.createElement(
	                  'span',
	                  null,
	                  _react2.default.createElement(
	                    'em',
	                    null,
	                    '2018 Health Care Cost and Utilization Report'
	                  )
	                )
	              ),
	              ' (HCCI, Feb. 2020).'
	            ),
	            _react2.default.createElement(
	              'li',
	              { id: '14' },
	              'Michael E. Chernew, Andrew L. Hicks, and Shivani A. Shah, \u201C',
	              _react2.default.createElement(
	                'a',
	                {
	                  href: 'https://www.healthaffairs.org/doi/abs/10.1377/hlthaff.2019.01377' },
	                _react2.default.createElement(
	                  'span',
	                  null,
	                  'Wide State-Level Variation in Commercial Health Care Prices Suggests Uneven Impact of Price Regulation'
	                )
	              ),
	              '," ',
	              _react2.default.createElement(
	                'em',
	                null,
	                'Health Affairs'
	              ),
	              ' 39, no. 5 (May 4, 2020): 791\u201399.'
	            ),
	            _react2.default.createElement(
	              'li',
	              { id: '15' },
	              'Christopher F. Koller, \u201C',
	              _react2.default.createElement(
	                'a',
	                {
	                  href: 'https://www.milbank.org/2019/02/health-care-costs-mapping-the-forest-and-finding-a-path/' },
	                _react2.default.createElement(
	                  'span',
	                  null,
	                  '\u201CHealth Care Costs \u2014 Mapping the Forest and Finding a Path'
	                )
	              ),
	              ',\u201D President\u2019s Blog, Milbank Memorial Fund, Feb. 21, 2019.'
	            ),
	            _react2.default.createElement(
	              'li',
	              { id: '16' },
	              'Mehrotra et al., ',
	              _react2.default.createElement(
	                'em',
	                null,
	                'Impact of COVID-19,'
	              ),
	              ' 2020.'
	            ),
	            _react2.default.createElement(
	              'li',
	              { id: '17' },
	              'OECD is the Organisation for Economic Co-operation and Development. See Christopher F. Koller and Dhruv Khullar \u201C',
	              _react2.default.createElement(
	                'a',
	                {
	                  href: 'https://www.nejm.org/doi/10.1056/NEJMp1709538' },
	                _react2.default.createElement(
	                  'span',
	                  null,
	                  '\u201CPrimary Care Spending Rate \u2014 A Lever for Encouraging Investment in Primary Care'
	                )
	              ),
	              ',\u201D ',
	              _react2.default.createElement(
	                'em',
	                null,
	                'New England Journal of Medicine'
	              ),
	              ' 377, no. 18 (Nov. 2, 2017): 1709\u201311.'
	            ),
	            _react2.default.createElement(
	              'li',
	              { id: '18' },
	              'Primary Care Collaborative, \u201C',
	              _react2.default.createElement(
	                'a',
	                {
	                  href: 'https://www.pcpcc.org/2020/05/06/primary-care-covid-19-week-8-survey' },
	                _react2.default.createElement(
	                  'span',
	                  null,
	                  'Primary Care & COVID-19: Week 8 Survey'
	                )
	              ),
	              ',\u201D PCC, May 6, 2020.'
	            )
	          )
	        )
	      )
	    )
	  );
	};
	
	//  Components
	exports.default = Theme2Page;
	var query = exports.query = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-spending-js-41d74cc23eaa343f19a5.js